module.exports = __webpack_public_path__ + "img/17-11.60c718ed.jpg";